import axios from "axios";

export const checkDomain = async (domain, subscriptionId) => {
  try {
    const response = await axios.post(`/api/Domain/CheckDomain`, {
      SubDomain: domain,
      SubscriptionId: subscriptionId,
    });

    if (response.data.Success) {
      return response.data.Payload.Availabllity;
    } else {
      return false;
    }
  } catch (error) {
    console.error(error);
  }
};

export const createTenant = async (domain, subscriptionId) => {
  try {
    const response = await axios.post(`/api/Domain/CreateTenant`, {
      SubDomain: domain,
      SubscriptionId: subscriptionId,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return false;
  }
};
